import React, {FC} from 'react';
import './App.css';
import {I18nextProvider} from "react-i18next";
import i18n from "./i18n";
import {AuthProvider} from "./config/AuthContext";
import {GlobalProvider} from "./config/GlobalContext";
import SBLayout from "./components/Layout/SBLayout";
import RouteGuard from "./components/RouteGuard";
import {App as AntdApp, ConfigProvider} from "antd";

const DevWatermark: FC = () => {
    if (process.env.REACT_APP_ENV !== 'local') return null;
    return (
        <div style={{
            position: 'fixed',
            inset: 0,
            pointerEvents: 'none',
            zIndex: 9999,
            overflow: 'hidden',
            userSelect: 'none',
        }}>
            <div style={{
                position: 'absolute',
                inset: '-50%',
                display: 'flex',
                flexWrap: 'wrap',
                transform: 'rotate(-30deg)',
                gap: '1rem 3rem',
                alignContent: 'flex-start',
                opacity: 0.07,
            }}>
                {Array.from({length: 60}).map((_, i) => (
                    <span key={i} style={{
                        fontSize: '1.3rem',
                        fontWeight: 'bold',
                        color: '#000',
                        whiteSpace: 'nowrap',
                        padding: '2rem 0',
                    }}>
                        Version de développement
                    </span>
                ))}
            </div>
        </div>
    );
};

const App: FC = () => {
    return (
        <ConfigProvider
            theme={{
                components: {
                    Segmented: {
                        itemSelectedBg: '#b7cfe1',
                        itemSelectedColor: '#370303',
                    },
                },
            }}
        >
        <AntdApp>
            <DevWatermark/>
            <I18nextProvider i18n={i18n}>
                <AuthProvider>
                    <RouteGuard>
                        <GlobalProvider>
                            <SBLayout/>
                        </GlobalProvider>
                    </RouteGuard>
                </AuthProvider>
            </I18nextProvider>
        </AntdApp>
        </ConfigProvider>
    );
}

export default App;
